export class BaseAirPriceRsp {

  airItinerary = new AirItinerary();

  airPriceResult: AirPriceResult[] = [];
}

export class AirPriceResult {

  airPricingSolution: AirPricingSolution[] = [];

  fareRule: FareRule[] = [];

  airPriceError = new typeResultMessage();

  commandKey: string;

}

export class AirItinerary {

  airSegment: typeBaseAirSegment[] = [];

  hostToken: HostToken[] = [];

  aPISRequirements: APISRequirements[] = [];
}

export class typeBaseAirSegment {

  sponsoredFltInfo = new SponsoredFltInfo();

  codeshareInfo = new CodeshareInfo();

  airAvailInfo: AirAvailInfo[] = [];

  flightDetails: FlightDetails[] = [];

  flightDetailsRef: FlightDetailsRef[] = [];

  alternateLocationDistanceRef: AlternateLocationDistanceRef[] = [];

  connection = new Connection();

  sellMessage: string[] = [];

  railCoachDetails: RailCoachDetails[] = [];

  openSegment: boolean;

  openSegmentSpecified: boolean;

  group: number;

  carrier: string;

  cabinClass: string;

  flightNumber: string;

  origin: string;

  destination: string;

  departureTime: string;

  arrivalTime: string;

  flightTime: string;

  travelTime: string;

  distance: string;

  providerCode: string;

  supplierCode: string;

  participantLevel: string;

  linkAvailability: boolean;

  linkAvailabilitySpecified: boolean;

  polledAvailabilityOption: string;

  availabilityDisplayType: string;

  classOfService: string;

  eTicketability: typeEticketability;

  eTicketabilitySpecified: boolean;

  equipment: string;

  marriageGroup: number;

  marriageGroupSpecified: boolean;

  numberOfStops: number;

  numberOfStopsSpecified: boolean;

  seamless: boolean;

  seamlessSpecified: boolean;

  changeOfPlane: boolean;

  guaranteedPaymentCarrier: string;

  hostTokenRef: string;

  providerReservationInfoRef: string;

  passiveProviderReservationInfoRef: string;

  optionalServicesIndicator: boolean;

  optionalServicesIndicatorSpecified: boolean;

  availabilitySource: string;

  aPISRequirementsRef: string;

  blackListed: boolean;

  blackListedSpecified: boolean;

  operationalStatus: string;

  numberInParty: string;

  railCoachNumber: string;

  bookingDate: Date;

  bookingDateSpecified: boolean;

  flownSegment: boolean;

  scheduleChange: boolean;

  brandIndicator: string;
}

export class SponsoredFltInfo {

  sponsoredLNB: string;

  neutralLNB: string;

  fltKey: string;
}

export class CodeshareInfo {

  operatingCarrier: string;

  operatingFlightNumber: string;

  value: string;
}

export class AirAvailInfo {

  bookingCodeInfo: BookingCodeInfo[] = [];

  fareTokenInfo: AirAvailInfoFareTokenInfo[] = [];

  providerCode: string;

  hostTokenRef: string;
}

export class BookingCodeInfo {

  cabinClass: string;

  bookingCounts: string;
}

export class AirAvailInfoFareTokenInfo {
  fareInfoRef: string;

  hostTokenRef: string;
}

export class FlightDetails {
  connection = new Connection();

  meals: typeMealService[] = [];

  inFlightServices: string[] = [];

  key: string;

  origin: string;

  destination: string;

  departureTime: string;

  arrivalTime: string;

  flightTime: string;

  travelTime: string;

  distance: string;

  equipment: string;

  groundTime: string;

  automatedCheckin: boolean;

  elStat: typeElementStatus;

  elStatSpecified: boolean;

  keyOverride: boolean;

  keyOverrideSpecified: boolean;

}

export class Connection {
  fareNote = new FareNote();

  changeOfPlane: boolean;

  changeOfTerminal: boolean;

  changeOfAirport: boolean;

  stopOver: boolean;

  minConnectionTime: number;

  minConnectionTimeSpecified: boolean;

  duration: number;

  durationSpecified: boolean;

  segmentIndex: number;

  segmentIndexSpecified: boolean;

  flightDetailsIndex: number;

  flightDetailsIndexSpecified: boolean;

  includeStopOverToFareQuote: typeIgnoreStopOver;

  includeStopOverToFareQuoteSpecified: boolean;

}

export class FareNote {
  key: string;

  precedence: string;

  noteName: string;

  fareInfoMessageRef: string;

  elStat: typeElementStatus;

  elStatSpecified: boolean;

  keyOverride: boolean;

  keyOverrideSpecified: boolean;

  value: string;
}

export enum typeIgnoreStopOver {
  /// <remarks/>
  NoStopOver,

  /// <remarks/>
  StopOver,

  /// <remarks/>
  IgnoreSegment,
}
export enum typeElementStatus {
  /// <remarks/>
  A,

  /// <remarks/>
  M,

  /// <remarks/>
  C,
}
export enum typeMealService {
  /// <remarks/>
  Meal,

  /// <remarks/>
  ColdMeal,

  /// <remarks/>
  HotMeal,

  /// <remarks/>
  Breakfast,

  /// <remarks/>
  ContinentalBreakfast,

  /// <remarks/>
  Lunch,

  /// <remarks/>
  Dinner,

  /// <remarks/>
  SnackOrBrunch,

  /// <remarks/>
  FoodForPurchase,

  /// <remarks/>
  ComplimentaryRefreshments,

  /// <remarks/>
  AlcoholicBeveragesForPurchase,

  /// <remarks/>
  ComplimentaryAlcoholicBeverages,

  /// <remarks/>
  FoodAndBeveragesForPurchase,

  /// <remarks/>
  NoMealService,

  /// <remarks/>
  RefreshmentsForPurchase,
}

export class FlightDetailsRef {
  key: string;
}

export class AlternateLocationDistanceRef {

  key: string;
}

export class RailCoachDetails {

  railCoachNumber: string;

  availableRailSeats: string;

  railSeatMapAvailability: boolean;

  railSeatMapAvailabilitySpecified: boolean;
}

export enum typeEticketability {

  /// <remarks/>
  Yes,

  /// <remarks/>
  No,

  /// <remarks/>
  Required,

  /// <remarks/>
  Ticketless,
}


export class HostToken {

  host: string;

  key: string;

  elStat : typeElementStatus;

  elStatSpecified: boolean;

  keyOverride: boolean;

  keyOverrideSpecified: boolean;

  value: string;
}

export class APISRequirements {

document: Document[]=[];

key: string;

level: string;

genderRequired: boolean;

genderRequiredSpecified: boolean;

dateOfBirthRequired: boolean;

dateOfBirthRequiredSpecified: boolean;

requiredDocuments: string;

nationalityRequired: boolean;

nationalityRequiredSpecified: boolean;

}

export class Document {

  sequence: string;

  type: string;

  level: string;

}



/************** Air Price Results and Air Pricing Soultions ****************/



export class AirPricingSolution {

  airSegment: typeBaseAirSegment[]=[];

  airSegmentRef: AirSegmentRef[]=[];

  journey: Journey[]=[];

  legRef: LegRef[]=[];

  airPricingInfo: AirPricingInfo[]=[];

  fareNote: FareNote[]=[];

  fareNoteRef: FareNoteRef[]=[];

  connection: Connection[]=[];

  metaData: MetaData[]=[];

  airPricingResultMessage: typeResultMessage[]=[];

  feeInfo: typeFeeInfo[]=[];

  taxInfo: typeTaxInfo[]=[];

  airItinerarySolutionRef: AirItinerarySolutionRef[]=[];

  hostToken: HostToken[]=[];

  optionalServices = new OptionalServices();

  availableSSR = new AvailableSSR();

  pricingDetails = new PricingDetails();

  key : string;

  completeItinerary : boolean;

  quoteDate: Date;

  quoteDateSpecified: boolean;

  totalPrice: string;

  basePrice: string;

  approximateTotalPrice: string;

  approximateBasePrice: string;

  equivalentBasePrice: string;

  taxes: string;

  fees: string;

  services: string;

  approximateTaxes: string;

  approximateFees: string;

  itinerary : AirPricingSolutionItinerary;

  itinerarySpecified: boolean;

}

export class FareRule {

  fareRuleLong: FareRuleLong[]=[];

  fareRuleShort: FareRuleShort[]=[];

  ruleAdvancedPurchase = new RuleAdvancedPurchase();

  ruleLengthOfStay = new RuleLengthOfStay();

  ruleCharges = new RuleCharges();

  fareRuleResultMessage: typeResultMessage[]=[];

  structuredFareRules: FareRuleCategoryTypes[]=[];

  fareInfoRef: string;

  ruleNumber: string;

  source: string;

  tariffNumber: string;

  providerCode: string;

  supplierCode: string;

}

export class typeResultMessage {

  code: string;

  type : typeResultMessageType;

  typeSpecified: boolean;

  value: string;

}

export enum typeResultMessageType {

  /// <remarks/>
  Warning,

  /// <remarks/>
  Error,

  /// <remarks/>
  Info,
}

export class AirSegmentRef {

  key: string;

}

export class Journey {

  airSegmentRef: AirSegmentRef[]=[];

  travelTime: string;

}

export class LegRef {

  key: string;
}

export class AirPricingInfo {

  fareInfo: FareInfo[]=[];

  fareStatus = new FareStatus();

  fareInfoRef: FareInfoRef[]=[];

  bookingInfo: BookingInfo[]=[];

  taxInfo: typeTaxInfo[]=[];

  fareCalc: string;

  passengerType: PassengerType[]=[];

  bookingTravelerRef: BookingTravelerRef[]=[];

waiverCode = new WaiverCode();

paymentRef: PaymentRef[]=[];

changePenalty: typeFarePenalty[]=[];

cancelPenalty: typeFarePenalty[]=[];

noShowPenalty: typeFarePenalty[]=[];

mostRestrictivePenalties: typeRestrictionData[]=[];

feeInfo: typeFeeInfo[]=[];

adjustment: Adjustment[]=[];

yield: Yield[]=[];

airPricingModifiers = new AirPricingModifiers();

ticketingModifiersRef: TicketingModifiersRef[]=[];

airSegmentPricingModifiers: AirSegmentPricingModifiers[]=[];

flightOptionsList: FlightOption[]=[];

baggageAllowances = new BaggageAllowances();

fareRulesFilter: FareRulesFilter;

policyCodesList: number[] = [];

priceChange: PriceChangeType[]=[];

actionDetails = new ActionDetails();

commission: Commission[]=[];

origin: string;

destination: string;

key: string;

commandKey: string;

totalPrice: string;

basePrice: string;

approximateTotalPrice: string;

approximateBasePrice: string;

equivalentBasePrice: string;

taxes: string;

fees: string;

services: string;

approximateTaxes: string;

approximateFees: string;

providerCode: string;

supplierCode: string;

amountType: string;

includesVAT: boolean;

includesVATSpecified: boolean;

exchangeAmount: string;

forfeitAmount: string;

refundable: boolean;

refundableSpecified: boolean;

exchangeable: boolean;

exchangeableSpecified: boolean;

latestTicketingTime: string;

pricingMethod : typePricingMethod;

checksum: string;

eTicketability: typeEticketability;

eTicketabilitySpecified: boolean;

platingCarrier: string;

providerReservationInfoRef: string;

airPricingInfoGroup: number;

airPricingInfoGroupSpecified: boolean;

totalNetPrice: string;

ticketed: boolean;

ticketedSpecified: boolean;

pricingType: string;

trueLastDateToTicket: string;

elStat : typeElementStatus;

elStatSpecified: boolean;

keyOverride: boolean;

keyOverrideSpecified: boolean;

inPolicy: boolean;

inPolicySpecified: boolean;

preferredOption: boolean;

preferredOptionSpecified: boolean;

fareCalculationInd: boolean;

cat35Indicator: boolean;

cat35IndicatorSpecified: boolean;

}

export class FareNoteRef {

  key: string;
}
export class MetaData {

  key: string;

  value: string;
}
export class typeFeeInfo {

  taxInfoRef: typeFeeInfoTaxInfoRef[]=[];

  includedInBase = new IncludedInBase();

baseAmount: string;

description: string;

subCode: string;

key: string;

amount: string;

code: string;

feeToken: string;

paymentRef: string;

bookingTravelerRef: string;

passengerTypeCode: string;

text: string;

providerCode: string;

supplierCode: string;

elStat: typeElementStatus;

elStatSpecified: boolean;

keyOverride: boolean;

keyOverrideSpecified: boolean;
}

export class typeTaxInfo {

  taxDetail: TaxDetail[]=[];

  includedInBase = new IncludedInBase();

key: string;

category: string;

carrierDefinedCategory: string;

segmentRef: string;

flightDetailsRef: string;

couponRef: string;

amount: string;

originAirport: string;

destinationAirport: string;

countryCode: string;

fareInfoRef: string;

taxExempted: boolean;

taxExemptedSpecified: boolean;

providerCode: string;

supplierCode: string;

text: string;
}

export class AirItinerarySolutionRef {

  key: string;

}
export class OptionalServices {

  optionalServicesTotal = new OptionalServicesOptionalServicesTotal();

  optionalService : OptionalService[]=[];

  groupedOptionInfo: GroupedOptionInfo[]=[];

  optionalServiceRules: ServiceRuleType[]=[];

}
export class AvailableSSR {

  sSR: SSR[]=[];

  sSRRules: ServiceRuleType[]=[];

  industryStandardSSR: IndustryStandardSSR[]=[];

}
export class PricingDetails {

  advisoryMessage: string[]=[];

  endorsementText: string[]=[];

waiverText: string;

lowFarePricing: boolean;

lowFareFound: boolean;

penaltyApplies: boolean;

discountApplies: boolean;

  itineraryType : typeItineraryCode;

itineraryTypeSpecified: boolean;

validatingVendorCode: string;

forTicketingOnDate: Date;

forTicketingOnDateSpecified: boolean;

lastDateToTicket: Date;

lastDateToTicketSpecified: boolean;

formOfRefund : typeFormOfRefund;

formOfRefundSpecified: boolean;

accountCode: string;

bankersSellingRate: number;

bankersSellingRateSpecified: boolean;

pricingType : typePricingType;

pricingTypeSpecified: boolean;

conversionRate: number;

conversionRateSpecified: boolean;

rateOfExchange: number;

rateOfExchangeSpecified: boolean;

originalTicketCurrency: string;
}

export enum AirPricingSolutionItinerary {

  /// <remarks/>
  New,

  /// <remarks/>
  Original,
}

export class FareRuleLong {

  category: string;

  type: string;

  value: string;
}
export class FareRuleShort {

fareRuleNameValue: FareRuleNameValue[]=[];

category: string;

tableNumber: string;

}
export class RuleAdvancedPurchase {

reservationLatestPeriod: string;

reservationLatestUnit: typeStayUnit;

reservationLatestUnitSpecified: boolean;

ticketingEarliestDate: string;

ticketingLatestDate: string;

moreRulesPresent: boolean;

moreRulesPresentSpecified: boolean;

}
export class RuleLengthOfStay {

  minimumStay = new typeRestrictionLengthOfStay();

  maximumStay = new typeRestrictionLengthOfStay();
}
export class RuleCharges {

penaltyType: string;

departureStatus: string;

amount: string;

percent: number;

percentSpecified: boolean;

moreRulesPresent: boolean;

moreRulesPresentSpecified: boolean;

}
export class FareRuleCategoryTypes {

  categoryDetails: ValueDetails[]=[];

  variableCategoryDetails: VariableCategoryType[]=[];

  value: string;
}

export class FareInfo {

  fareTicketDesignator: FareTicketDesignator[]=[];

  ticketingCode: TicketingCode[]=[];

  fareSurcharge: FareSurcharge[]=[];

  accountCode: AccountCode[]=[];

  contractCode: ContractCode[]=[];

  endorsement: Endorsement[]=[];

  baggageAllowance = new BaggageAllowance();

  fareRuleKey = new FareRuleKey();

  fareRuleFailureInfo: string[]=[];

  fareRemarkRef: FareRemarkRef[]=[];

  brand = new Brand();

  commission = new Commission();

  fareAttributes: string;

  changePenalty = new typeFarePenalty();

  cancelPenalty = new typeFarePenalty();

  fareRulesFilter = new FareRulesFilter();

  key: string;

  fareBasis: string;

  passengerTypeCode: string;

  origin: string;

  destination: string;

  effectiveDate: string;

  travelDate: Date;

  travelDateSpecified: boolean;

  departureDate: Date;

  departureDateSpecified: boolean;

  amount: string;

  privateFare : typePrivateFare;

  privateFareSpecified: boolean;

  negotiatedFare: boolean;

  negotiatedFareSpecified: boolean;

  tourCode: string;

  waiverCode: string;

  notValidBefore: Date;

  notValidBeforeSpecified: boolean;

  notValidAfter: Date;

  notValidAfterSpecified: boolean;

  pseudoCityCode: string;

  fareFamily: string;

  promotionalFare: boolean;

  promotionalFareSpecified: boolean;

  carCode: string;

  valueCode: string;

  elStat: typeElementStatus;

  elStatSpecified: boolean;

  keyOverride: boolean;

  keyOverrideSpecified: boolean;

  bulkTicket: boolean;

  bulkTicketSpecified: boolean;

  inclusiveTour: boolean;

  inclusiveTourSpecified: boolean;

  value: string;

  supplierCode: string;

  taxAmount: string;
}
export class FareStatus {

  fareStatusFailureInfo = new FareStatusFailureInfo();

  code : typeFareStatusCode;
}
export class FareInfoRef {

  key: string;
}
export class BookingInfo {

  bookingCode: string;

  bookingCount: string;

  cabinClass: string;

  fareInfoRef: string;

  segmentRef: string;

  couponRef: string;

  airItinerarySolutionRef: string;

  hostTokenRef: string;

  taxInfoRef: string;
}

export class FareGuaranteeInfo {

  guaranteeDate: Date;

  guaranteeDateSpecified: boolean;

  guaranteeType : typeFareGuarantee;
}
export enum typeFareGuarantee {

  /// <remarks/>
  Auto,

  /// <remarks/>
  Manual,

  /// <remarks/>
  ManualFare,

  /// <remarks/>
  Guaranteed,

  /// <remarks/>
  Invalid,

  /// <remarks/>
  Restored,

  /// <remarks/>
  Ticketed,

  /// <remarks/>
  Unticketable,

  /// <remarks/>
  Reprice,

  /// <remarks/>
  Expired,

  /// <remarks/>
  AutoUsingPrivateFare,

  /// <remarks/>
  GuaranteedUsingAirlinePrivateFare,

  /// <remarks/>
  Airline,

  /// <remarks/>
  GuaranteeExpired,

  /// <remarks/>
  AgencyPrivateFareNoOverride,

  /// <remarks/>
  Unknown,
}
export class BookingTravelerRef {

  loyaltyCardRef: LoyaltyCardRef[]=[];

  driversLicenseRef = new DriversLicenseRef();

  discountCardRef: DiscountCardRef[]=[];

  paymentRef: PaymentRef1[]=[];

  key: string;
}
export class WaiverCode {

  tourCode: string;

  ticketDesignator: string;

  endorsement: string;
}
export class PaymentRef {

  key: string;
}
export class typeFarePenalty {

  amount: string;

  percentage: string;

  penaltyApplies : typeFarePenaltyPenaltyApplies;

  penaltyAppliesSpecified: boolean;

  noShow: boolean;

  noShowSpecified: boolean;
}
export class typeRestrictionData {

  amount: string;

  percentage: string;

  name: string;

  value: string;
}
export class Adjustment {

  item: object;

  adjustedTotalPrice: string;

  approximateAdjustedTotalPrice: string;

  bookingTravelerRef: string;
}
export class Yield {

  amount: string;

  bookingTravelerRef: string;
}
export class AirPricingModifiers {

  prohibitedRuleCategories : FareRuleCategory[]=[];

  accountCodes: AccountCode[]=[];

  permittedCabins: CabinClass[]=[];

  contractCodes: ContractCode[]=[];

  exemptTaxes = new ExemptTaxes();

  penaltyFareInformation = new PenaltyFareInformation();

  discountCard: DiscountCard[]=[];

  promoCodes: PromoCode[]=[];

  manualFareAdjustment: ManualFareAdjustment[]=[];

  pointOfSale = new PointOfSale();

  brandModifiers = new BrandModifiers();

  multiGDSSearchIndicator : MultiGDSSearchIndicator[]=[];

  preferredCabins: PreferredCabins[]=[];

  prohibitMinStayFares: boolean;

  prohibitMaxStayFares: boolean;

  currencyType: string;

  prohibitAdvancePurchaseFares: boolean;

  prohibitNonRefundableFares: boolean;

  prohibitRestrictedFares: boolean;

  faresIndicator : typeFaresIndicator;

  faresIndicatorSpecified: boolean;

  filedCurrency: string;

  platingCarrier: string;

  overrideCarrier: string;

  eTicketability :  typeEticketability;

  eTicketabilitySpecified: boolean;

  accountCodeFaresOnly: boolean;

  accountCodeFaresOnlySpecified: boolean;

  key: string;

  prohibitNonExchangeableFares: boolean;

  forceSegmentSelect: boolean;

  inventoryRequestType : typeInventoryRequest;

  inventoryRequestTypeSpecified: boolean;

  oneWayShop: boolean;

  prohibitUnbundledFareTypes: boolean;

  prohibitUnbundledFareTypesSpecified: boolean;

  returnServices: boolean;

  channelId: string;

  returnFareAttributes: boolean;

  sellCheck: boolean;

  returnFailedSegments: boolean;

  sellCity: string;

  ticketingCity: string;

}

export class TicketingModifiersRef {

  key : string;
}
export class AirSegmentPricingModifiers {

  permittedBookingCodes : BookingCode[]=[];

  airSegmentRef: string;

  cabinClass: string;

  accountCode: string;

  prohibitAdvancePurchaseFares: boolean;

  prohibitNonRefundableFares: boolean;

  prohibitPenaltyFares: boolean;

  fareBasisCode: string;

  fareBreak : typeFareBreak;

  fareBreakSpecified: boolean;

  connectionIndicator : typeConnectionIndicator;

  connectionIndicatorSpecified: boolean;

  brandTier: string;

}
export class FlightOption {

  option: Option[]=[];

  legRef: string;

  origin: string;

  destination: string;
}
export class Option {

  bookingInfo: BookingInfo[]=[];

  connection: Connection[]=[];

  key: string;

  travelTime: string;
}
export class BaggageAllowances {

  baggageAllowanceInfo: BaggageAllowanceInfo[]=[];

  carryOnAllowanceInfo: CarryOnAllowanceInfo[]=[];

  embargoInfo: BaseBaggageAllowanceInfo[]=[];
}
export class BaggageAllowanceInfo
{
        
  bagDetails: BagDetails[]=[];

  travelerType: string;

  fareInfoRef: string;
}
export class BagDetails {

  baggageRestriction: BaggageRestriction[]=[];

  availableDiscount: AvailableDiscount[]=[];

  applicableBags: string;

  basePrice: string;

  approximateBasePrice: string;

  taxes: string;

  totalPrice: string;

  approximateTotalPrice: string;
}
export class FareRulesFilter {

  refundability: FareRulesFilterRefundability;

  latestTicketingTime: Date | string;

  latestTicketingTimeSpecified: boolean;

  cHG : PenFeeType[]=[];

  mIN : MINType;

  mAX : MAXType;

  aDV : ADVType;

  oTH : OTHType;
}
export class PriceChangeType {
  amount: string;
  carrier: string;
  segmentRef: string;
  value: string;
}
export class ActionDetails {
  pseudoCityCode: string;
  agentSine: string;
  eventDate: string;
  eventDateSpecified: boolean;
  eventTime: string;
  eventTimeSpecified: boolean;
  text: string;
}

export class Commission {
  key: string;
  level: typeCommissionLevel;
  type: typeCommissionType;
  modifier: typeCommissionModifier;
  modifierSpecified: boolean;
  amount: string;
  value: string;
  percentage: string;
  bookingTravelerRef: string;
  commissionOverride: boolean;
}
export enum typePricingMethod {
  Auto,
  Manual,
  ManualFare,
  Guaranteed,
  Invalid,
  Restored,
  Ticketed,
  Unticketable,
  Reprice,
  Expired,
  AutoUsingPrivateFare,
  GuaranteedUsingAirlinePrivateFare,
  Airline,
  AgentAssisted,
  VerifyPrice,
  AltSegmentRemovedReprice,
  AuxiliarySegmentRemovedReprice,
  DuplicateSegmentRemovedReprice,
  Unknown,
  GuaranteedUsingAgencyPrivateFare,
  AutoRapidReprice
}
export class typeFeeInfoTaxInfoRef {

  key: string;
}
export class IncludedInBase {

  amount: string;
}
export class TaxDetail {
  amount: string;
  originAirport: string;
  destinationAirport: string;
  countryCode: string;
  fareInfoRef: string;
}
export class OptionalServicesOptionalServicesTotal {
  taxInfo: typeTaxInfo[]=[];
  feeInfo: typeFeeInfo[]=[];
  totalPrice: string;
  basePrice: string;
  approximateTotalPrice: string;
  approximateBasePrice: string;
  equivalentBasePrice: string;
  taxes: string;
  fees: string;
  services: string;
  approximateTaxes: string;
  approximateFees: string;
}
export class OptionalService {

  serviceData: ServiceData[];

  serviceInfo: ServiceInfo;

  remark: Remark[];

  taxInfo: typeTaxInfo[];

  feeInfo: typeFeeInfo[];

  eMD: EMD;

  bundledServices: BundledService[];

  additionalInfo: AdditionalInfo[];

  feeApplication: FeeApplication;

  text: typeTextElement[];

priceRange: PriceRange[];

tourCode: TourCode;

brandingInfo: BrandingInfo;

title: typeTextElement[];

providerCode: string;

supplierCode: string;

optionalServicesRuleRef: string;

type: string;

confirmation: string;

secondaryType: string;

purchaseWindow: typePurchaseWindow;

purchaseWindowSpecified: boolean;

priority: string;

available: boolean;

availableSpecified: boolean;

entitled: boolean;

entitledSpecified: boolean;

perTraveler: boolean;

createDate: Date;

createDateSpecified: boolean;

paymentRef: string;

serviceStatus: string;

quantity: string;

sequenceNumber: string;

serviceSubCode: string;

sSRCode: string;

issuanceReason: string;

providerDefinedType: string;

totalPrice: string;

basePrice: string;

approximateTotalPrice: string;

approximateBasePrice: string;

equivalentBasePrice: string;

taxes: string;

fees: string;

services: string;

approximateTaxes: string;

approximateFees: string;

key: string;

assessIndicator: typeAssessIndicator;

assessIndicatorSpecified: boolean;

mileage: string;

applicableFFLevel: string;

private: boolean;

privateSpecified;

sSRFreeText: string;

isPricingApproximate: boolean;

isPricingApproximateSpecified: boolean;

elStat: typeElementStatus;

elStatSpecified: boolean;

keyOverride: boolean;

keyOverrideSpecified: boolean;

chargeable: string;

inclusiveOfTax: boolean;

inclusiveOfTaxSpecified: boolean;

interlineSettlementAllowed: boolean;

interlineSettlementAllowedSpecified: boolean;

geographySpecification: string;

excessWeightRate: string;

source: string;

viewableOnly: boolean;

viewableOnlySpecified: boolean;

displayText: string;

weightInExcess: string;

totalWeight: string;

baggageUnitPrice: string;

firstPiece: number;

firstPieceSpecified: boolean;

lastPiece: number;

lastPieceSpecified: boolean;

restricted: boolean;

isRepriceRequired: boolean;

bookedQuantity: string;

group: string;

pseudoCityCode: string;

tag: string;

displayOrder: string;
}
export class GroupedOptionInfo {

  items: GroupedOption[];
}
export class GroupedOption {

  optionalServiceRef: string;
}

export class ServiceRuleType {
  applicationRules: ServiceRuleTypeApplicationRules;
  applicationLevel: ServiceRuleTypeApplicationLevel;
  modifyRules: ServiceRuleTypeModifyRules;
  secondaryTypeRules: ServiceRuleTypeSecondaryTypeRule[];
  remarks: FormattedTextTextType[];
  key: string;
}

export class SSR {
  key: string;
  segmentRef: string;
  passiveSegmentRef: string;
  providerReservationInfoRef: string;
  type: string;
  status: string;
  freeText: string;
  carrier: string;
  carrierSpecificText: string;
  description: string;
  providerDefinedType: string;
  sSRRuleRef: string;
  uRL: string;
  elStat: typeElementStatus;
  elStatSpecified: boolean;
  keyOverride: boolean;
  keyOverrideSpecified: boolean;
  profileID: string;
  profileSecureFlightDocKey: string;
}
export class IndustryStandardSSR {

  code: string;
}
export enum typeItineraryCode {

  International,

  Domestic,
}
export enum typeFormOfRefund {

  MCO,
  FormOfPayment,
}
export enum typePricingType {

  ClassBooked,
  LowestClass,
  LowestQuote,
}
export class FareRuleNameValue {

  name: string;

  value: string;
}
export enum typeStayUnit {

  Minutes,
  Hours,
  Days,
  Months,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
  Sunday,
}

export class typeRestrictionLengthOfStay {
  length: string;
  stayUnit: typeStayUnit;
  stayUnitSpecified: boolean;
  stayDate: string;
  stayDateSpecified: boolean;
  moreRulesPresent: boolean;
  moreRulesPresentSpecified: boolean;
}
export class ValueDetails {

  name: string;

  value: string;
}

export class VariableCategoryType {
  categoryDetails: ValueDetails[];
  variableCategoryDetail: CategoryDetailsType[];
  value: string;
}
export class FareTicketDesignator {

  value: string;
}
export class TicketingCode {

  value: string;
}

export class FareSurcharge {
  key: string;
  type: string;
  amount: string;
  segmentRef: string;
  couponRef: string;
  elStat: typeElementStatus;
  elStatSpecified: boolean;
  keyOverride: boolean;
  keyOverrideSpecified: boolean;
}
export class AccountCode {
  code: string;
  providerCode: string;
  supplierCode: string;
  type: string;
}
export class ContractCode {
  code: string;
  companyName: string;
  providerCode: string;
  supplierCode: string;
}
export class Endorsement {

  value: string;
}
export class BaggageAllowance {

  numberOfPieces: string;

  maxWeight: typeWeight;
}

export class typeWeight {
  value: string;
  unit: typeUnitWeight;
  unitSpecified: boolean;
}
export enum typeUnitWeight {

  /// <remarks/>
  Kilograms,

  /// <remarks/>
  Pounds,
}
export class FareRuleKey {
  fareInfoRef: string;
  providerCode: string;
  value: string;
}
export class FareRemarkRef {

  key: string;
}

export class Brand {
  title: typeTextElement[];
  text: typeTextElement[];
  imageLocation: ImageLocation[];
  optionalServices: OptionalServices;
  rules: Rules[];
  serviceAssociations: ServiceAssociationsApplicableSegment[];
  upsellBrand: UpsellBrand;
  applicableSegment: typeApplicableSegment[];
  defaultBrandDetail: typeDefaultBrandDetail[];
  key: string;
  brandID: string;
  name: string;
  airItineraryDetailsRef: string;
  upSellBrandID: string;
  brandFound: boolean;
  brandFoundSpecified: boolean;
  upSellBrandFound: boolean;
  upSellBrandFoundSpecified: boolean;
  brandedDetailsAvailable: boolean;
  brandedDetailsAvailableSpecified: boolean;
  carrier: string;
  brandTier: string;
  brandMaintained: string;
}
export enum typePrivateFare {

  /// <remarks/>
  UnknownType,

  /// <remarks/>
  PrivateFare,

  /// <remarks/>
  AgencyPrivateFare,

  /// <remarks/>
  AirlinePrivateFare,
}
export class FareStatusFailureInfo {

  code: string;

  reason: string;
}
export enum typeFareStatusCode {

  /// <remarks/>
  ReadyToTicket,

  /// <remarks/>
  UnableToTicket,

  /// <remarks/>
  Reprice,

  /// <remarks/>
  Ticketed,

  /// <remarks/>
  Unable,

  /// <remarks/>
  Unknown,
}
export class LoyaltyCardRef {

  key: string;
}
export class DriversLicenseRef {

  key: string;
}
export class DiscountCardRef {

  key: string;
}
export class PaymentRef1 {
  key: string;
}
export enum typeFarePenaltyPenaltyApplies {

  Anytime,
  BeforeDeparture,
  AfterDeparture
}
export class FareRuleCategory {

  category: string;
}
export class CabinClass {

  type: string;
}
export class ExemptTaxes {
  countryCode: string[];
  taxCategory: string[];
  allTaxes: boolean;
  allTaxesSpecified: boolean;
  taxTerritory: string;
  companyName: string;
}
export class PenaltyFareInformation {

  penaltyInfo: typeFarePenalty;

  prohibitPenaltyFares: boolean;
}

export class DiscountCard {
  key: string;
  code: string;
  description: string;
  number: string;
  elStat: typeElementStatus;
  elStatSpecified: boolean;
  keyOverride: boolean;
  keyOverrideSpecified: boolean;
}
export class PromoCode {
  code: string;
  providerCode: string;
  supplierCode: string;
}

export class ManualFareAdjustment {
  appliedOn: typeAdjustmentTarget;
  adjustmentType: typeAdjustmentType;
  value: number;
  passengerRef: string;
  ticketDesignator: string;
  fareType: string;
}
export class PointOfSale {
  providerCode: string;
  pseudoCityCode: string;
  key: string;
  iATA: string;
}
export class BrandModifiers {

  item: any;
}
export class MultiGDSSearchIndicator {
  type: string;
  providerCode: string;
  defaultProvider: boolean;
  defaultProviderSpecified: boolean;
  privateFareCode: string;
  privateFareCodeOnly: boolean;
  privateFareCodeOnlySpecified: boolean;
}
export class PreferredCabins {

  cabinClass: CabinClass;
}
export enum typeFaresIndicator {

  /// <remarks/>
  PublicFaresOnly,

  /// <remarks/>
  PrivateFaresOnly,

  /// <remarks/>
  AgencyPrivateFaresOnly,

  /// <remarks/>
  AirlinePrivateFaresOnly,

  /// <remarks/>
  PublicAndPrivateFares,

  /// <remarks/>
  NetFaresOnly,

  /// <remarks/>
  AllFares,
}
export enum typeInventoryRequest {

  /// <remarks/>
  Seamless,

  /// <remarks/>
  DirectAccess,

  /// <remarks/>
  Basic,
}
export class BookingCode {

  code: string;
}
export enum typeFareBreak {

  /// <remarks/>
  MustBreak,

  /// <remarks/>
  MustOnlyBreak,

  /// <remarks/>
  MustNotBreak,
}
export enum typeConnectionIndicator {

  /// <remarks/>
  AvailabilityAndPricing,

  /// <remarks/>
  TurnAround,

  /// <remarks/>
  Stopover,
}

export interface CarryOnAllowanceInfo extends BaseBaggageAllowanceInfo {
  carryOnDetails: CarryOnAllowanceInfoCarryOnDetails[];
}

export class CarryOnAllowanceInfoCarryOnDetails {
  baggageRestriction: BaggageRestriction[];
  applicableCarryOnBags: string;
  basePrice: string;
  approximateBasePrice: string;
  taxes: string;
  totalPrice: string;
  approximateTotalPrice: string;
}

export class BaseBaggageAllowanceInfo {
  uRLInfo: URLInfo[];
  textInfo: TextInfo[];
  origin: string;
  destination: string;
  carrier: string;
}

export class BaggageRestriction {
  dimension: Dimension[];
  maxWeight: typeUnitOfMeasure[];
  textInfo: TextInfo[];
}

export class AvailableDiscount {
  loyaltyProgram: LoyaltyProgram[];
  amount: string;
  percent: string;
  description: string;
  discountQualifier: string;
}
export class FareRulesFilterRefundability {

  value : string;
}
export class PenFeeType {
  depRequired: boolean;
  depRequiredSpecified: boolean;
  depNonRef: boolean;
  depNonRefSpecified: boolean;
  tkNonRef: boolean;
  tkNonRefSpecified: boolean;
  airVFee: boolean;
  airVFeeSpecified: boolean;
  cancellation: boolean;
  cancellationSpecified: boolean;
  failConfirmSpace: boolean;
  failConfirmSpaceSpecified: boolean;
  itinChg: boolean;
  itinChgSpecified: boolean;
  replaceTk: boolean;
  replaceTkSpecified: boolean;
  applicable: boolean;
  applicableSpecified: boolean;
  applicableTo: boolean;
  applicableToSpecified: boolean;
  amt: number;
  amtSpecified: boolean;
  type: string;
  currency: string;
}
export class MINType {
  hoursMin: boolean;
  hoursMinSpecified: boolean;
  daysMin: boolean;
  daysMinSpecified: boolean;
  monthsMin: boolean;
  monthsMinSpecified: boolean;
  occurIndMin: boolean;
  occurIndMinSpecified: boolean;
  sameDayMin: boolean;
  sameDayMinSpecified: boolean;
  tmDOWMin: string;
  fareComponent: string;
  numOccurMin: string;
}
export class MAXType {
  hoursMax: boolean;
  hoursMaxSpecified: boolean;
  daysMax: boolean;
  daysMaxSpecified: boolean;
  monthsMax: boolean;
  monthsMaxSpecified: boolean;
  occurIndMax: boolean;
  occurIndMaxSpecified: boolean;
  sameDayMax: boolean;
  sameDayMaxSpecified: boolean;
  startIndMax: boolean;
  startIndMaxSpecified: boolean;
  completionInd: boolean;
  completionIndSpecified: boolean;
  tmDOWMax: string;
  numOccurMax: string;
}
export class ADVType {

  advRsvnOnlyIfTk: boolean;

  advRsvnOnlyIfTkSpecified: boolean;

  advRsvnAnyTm: boolean;

  advRsvnAnyTmSpecified: boolean;

  advRsvnHrs: boolean;

  advRsvnHrsSpecified: boolean;

  advRsvnDays: boolean;

  advRsvnDaysSpecified: boolean;

  advRsvnMonths: boolean;

  advRsvnMonthsSpecified: boolean;

  advRsvnEarliestTm: boolean;

  advRsvnEarliestTmSpecified: boolean;

  advRsvnLatestTm: boolean;

  advRsvnLatestTmSpecified: boolean;

  advRsvnWaived: boolean;

  advRsvnWaivedSpecified: boolean;

  advRsvnDataExists: boolean;

  advRsvnDataExistsSpecified: boolean;

  advRsvnEndItem: boolean;

  advRsvnEndItemSpecified: boolean;

  advTkEarliestTm: boolean;

  advTkEarliestTmSpecified: boolean;

  advTkLatestTm: boolean;

  advTkLatestTmSpecified: boolean;

  advTkRsvnHrs: boolean;

  advTkRsvnHrsSpecified: boolean;

  advTkRsvnDays: boolean;

  advTkRsvnDaysSpecified: boolean;

  advTkRsvnMonths: boolean;

  advTkRsvnMonthsSpecified: boolean;

  advTkStartHrs: boolean;

  advTkStartHrsSpecified: boolean;

  advTkStartDays: boolean;

  advTkStartDaysSpecified: boolean;

  advTkStartMonths: boolean;

  advTkStartMonthsSpecified: boolean;

  advTkWaived: boolean;

  advTkWaivedSpecified: boolean;

  advTkAnyTm: boolean;

  advTkAnyTmSpecified: boolean;

  advTkEndItem: boolean;

  advTkEndItemSpecified: boolean;

  advRsvnTm: string;

  advTkRsvnTm: string;

  advTkStartTm: string;

  earliestRsvnDtPresent: boolean;

  earliestRsvnDtPresentSpecified: boolean;

  earliestTkDtPresent: boolean;

  earliestTkDtPresentSpecified: boolean;

  latestRsvnDtPresent: boolean;

  latestRsvnDtPresentSpecified: boolean;

  latestTkDtPresent: boolean;

  latestTkDtPresentSpecified: boolean;

  earliestRsvnDt: Date;

  earliestRsvnDtSpecified: boolean;

  earliestTkDt: Date;

  earliestTkDtSpecified: boolean;

  latestRsvnDt: Date;

  latestRsvnDtSpecified: boolean;

  latestTkDt: Date;

  latestTkDtSpecified: boolean;

}

export class OTHType {

  cat0: boolean;

  cat0Specified: boolean;

  cat1: boolean;

  cat1Specified: boolean;

  cat2: boolean;

  cat2Specified: boolean;

  cat3: boolean;

  cat3Specified: boolean;

  cat4: boolean;

  cat4Specified: boolean;

  cat5: boolean;

  cat5Specified: boolean;

  cat6: boolean;

  cat6Specified: boolean;

  cat7: boolean;

  cat7Specified: boolean;

  cat8: boolean;

  cat8Specified: boolean;

  cat9: boolean;

  cat9Specified: boolean;

  cat10: boolean;

  cat10Specified: boolean;

  cat11: boolean;

  cat11Specified: boolean;

  cat12: boolean;

  cat12Specified: boolean;

  cat13: boolean;

  cat13Specified: boolean;

  cat14: boolean;

  cat14Specified: boolean;

  cat15: boolean;

  cat15Specified: boolean;

  cat16: boolean;

  cat16Specified: boolean;

  cat17: boolean;

  cat17Specified: boolean;

  cat18: boolean;

  cat18Specified: boolean;

  cat19: boolean;

  cat19Specified: boolean;

  cat20: boolean;

  cat20Specified: boolean;

  cat21: boolean;

  cat21Specified: boolean;

  cat22: boolean;

  cat22Specified: boolean;

  cat23: boolean;

  cat23Specified: boolean;

  cat24: boolean;

  cat24Specified: boolean;

  cat25: boolean;

  cat25Specified: boolean;

  cat26: boolean;

  cat26Specified: boolean;

  cat27: boolean;

  cat27Specified: boolean;

  cat28: boolean;

  cat28Specified: boolean;

  cat29: boolean;

  cat29Specified: boolean;

  cat30: boolean;

  cat30Specified: boolean;

  cat31: boolean;

  cat31Specified: boolean;

  restrictiveDt: Date | string;

  restrictiveDtSpecified: boolean;

  surchargeAmt: number;

  surchargeAmtSpecified: boolean;

  notUSACity: boolean;

  notUSACitySpecified: boolean;

  missingRules: boolean;

  missingRulesSpecified: boolean;
}
export enum typeCommissionLevel {

  /// <remarks/>
  Recalled,

  /// <remarks/>
  Fare,

  /// <remarks/>
  Penalty,
}
export enum typeCommissionType {

  /// <remarks/>
  Flat,

  /// <remarks/>
  PercentBase,

  /// <remarks/>
  PercentTotal,
}

export enum typeCommissionModifier {

  /// <remarks/>
  FarePercent,

  /// <remarks/>
  FareAmount,

  /// <remarks/>
  CommissionAmount,

  /// <remarks/>
  LessStandardCommission,

  /// <remarks/>
  StandardPlusSupplementaryPercent,

  /// <remarks/>
  SupplementaryPercent,

  /// <remarks/>
  SupplementaryAmount,
}

export class ServiceData {
  seatAttributes: SeatAttribute[];
  cabinClass: CabinClass;
  sSRRef: typeKeyBasedReference[];
  data: string;
  airSegmentRef: string;
  bookingTravelerRef: string;
  stopOver: boolean;
  travelerType: string;
  eMDSummaryRef: string;
  eMDCouponRef: string;
}
export class ServiceInfo {

  description: string[];

  mediaItem: MediaItem[];
}
export class Remark {

  key: string;

  value: string;
}

export class EMD {
  fulfillmentType: string;
  fulfillmentTypeDescription: string;
  associatedItem: string;
  availabilityChargeIndicator: EMDAvailabilityChargeIndicator;
  availabilityChargeIndicatorSpecified: boolean;
  refundReissueIndicator: EMDRefundReissueIndicator;
  refundReissueIndicatorSpecified: boolean;
  commissionable: boolean;
  commissionableSpecified: boolean;
  mileageIndicator: boolean;
  mileageIndicatorSpecified: boolean;
  location: string;
  date: string;
  dateSpecified: boolean;
  booking: EMDBooking;
  bookingSpecified: boolean;
  displayCategory: EMDDisplayCategory;
  displayCategorySpecified: boolean;
  reusable: boolean;
  reusableSpecified: boolean;
}

export class BundledService {
  carrier: string;
  carrierSubCode: boolean;
  carrierSubCodeSpecified: boolean;
  serviceType: string;
  serviceSubCode: string;
  name: string;
  booking: EMDBooking;
  bookingSpecified: boolean;
  occurrence: string;
}
export class AdditionalInfo {

  category: string;

}
export class FeeApplication {

  code: string;

  value: string;
}
export class typeTextElement {

  type: string;

  languageCode: string;

  value: string;
}
export class PriceRange {

  defaultCurrency: boolean;

  defaultCurrencySpecified: boolean;

  startPrice: string;

  endPrice: string;
}
export class TourCode {

  value: string;
}

export class BrandingInfo {
  priceRange: PriceRange[];
  text: typeTextElement[];
  title: typeTextElement[];
  imageLocation: ImageLocation[];
  serviceGroup: ServiceGroup;
  airSegmentRef: typeSegmentRef[];
  key: string;
  serviceSubCode: string;
  externalServiceName: string;
  serviceType: string;
  commercialName: string;
  chargeable: string;
}
export enum typePurchaseWindow {
  BookingOnly,
  TicketingOnly,
  CheckInOnly,
  Anytime,
  PostTicketing,
}
export enum typeAssessIndicator {
  MileageAndCurrency,
  MileageOrCurrency,
}
export class ServiceRuleTypeApplicationRules {
  requiredForAllTravelers: boolean;
  requiredForAllTravelersSpecified: boolean;
  requiredForAllSegments: boolean;
  requiredForAllSegmentsSpecified: boolean;
  requiredForAllSegmentsInOD: boolean;
  requiredForAllSegmentsInODSpecified: boolean;
  unselectedOptionRequired: boolean;
  unselectedOptionRequiredSpecified: boolean;
  secondaryOptionCodeRequired: boolean;
  secondaryOptionCodeRequiredSpecified: boolean;
}

export class ServiceRuleTypeApplicationLevel {
  applicationLimits: OptionalServiceApplicationLimitType[];
  serviceData: ServiceData[];
  applicableLevels: OptionalServiceApplicabilityType[];
  providerDefinedApplicableLevels: string;
}
export class ServiceRuleTypeModifyRules {
  modifyRule: ServiceRuleTypeModifyRulesModifyRule[];
  supportedModifications: ModificationType[];
  providerDefinedModificationType: string;
}
export class ServiceRuleTypeSecondaryTypeRule {

  applicationLimit: OptionalServiceApplicationLimitType[];

  secondaryType: string;
}
export class FormattedTextTextType {
  formatted: boolean;
  formattedSpecified: boolean;
  language: string;
  textFormat: FormattedTextTextTypeTextFormat;
  textFormatSpecified: boolean;
  value: string;
}
export class CategoryDetailsType {

  categoryDetails: ValueDetails[];

  value: string;
}
export class ImageLocation {
  type: string;
  imageWidth: string;
  imageHeight: string;
  value: string;
}
export class Rules {

  rulesText: string;
}
export class ServiceAssociationsApplicableSegment {

  item: any;

  key: string;
}
export class UpsellBrand {

  fareBasis: string;

  fareInfoRef: string;
}
export class typeApplicableSegment {

  key: string;

  airItineraryDetailsRef: string;

  bookingCounts: string;
}
export class typeDefaultBrandDetail {
  text: typeTextElement[];
  imageLocation: ImageLocation[];
  applicableSegment: typeApplicableSegment[];
  brandID: string;
}
export enum typeAdjustmentTarget {
  Base,
  Total,
  Other,
}
export enum typeAdjustmentType {
  Amount,
  Percentage,
}
export class URLInfo {
  text: string[];
  uRL: string[];
}
export class TextInfo {
  text: string[];
  title: string;
}
export class typeUnitOfMeasure {

  value: number;

  valueSpecified: boolean;

  unit: string;
}
export class Dimension extends typeUnitOfMeasure
{

  type: string;
}

export class LoyaltyProgram {
  key: string;
  supplierCode: string;
  allianceLevel: string;
  membershipProgram: string;
  level: string;
}
export class SeatAttribute {

  value: string;
}
export class typeKeyBasedReference {

  key: string;
}
export class MediaItem {
  caption: string;
  height: string;
  width: string;
  type: string;
  url: string;
  icon: string;
  sizeCode: string;
}
export enum EMDAvailabilityChargeIndicator {
  X,
  E,
  F,
  G,
  H,
}
export enum EMDRefundReissueIndicator {
  Refundable,
  NonRefundable,
  Reuse,
}
export enum EMDBooking {
  SSR,
  AuxillarySegment,
  AvailableforDisplayPricing,
  ContactCarrierforBooking,
  NoBookingRequired,
  Applybookingperservice
}
export enum EMDDisplayCategory {
  WithItineraryPricing,
  Store,
  SpecialService,
}
export class ServiceGroup {

  serviceSubGroup: ServiceSubGroup[];

  code: string;
}
export class typeSegmentRef {

  key: string;
}

export interface OptionalServiceApplicationLimitType {
  applicableLevel: OptionalServiceApplicabilityType;
  providerDefinedApplicableLevels: string;
  maximumQuantity: string;
  minimumQuantity: string;
}
export enum OptionalServiceApplicabilityType {

  Itinerary,
  Passenger,
  Segment,
  PassengerSegment,
  PassengerOD,
  Other,
}

export interface ServiceRuleTypeModifyRulesModifyRule {
  modification: ModificationType;
  automaticallyAppliedOnAdd: boolean;
  canDelete: boolean;
  canDeleteSpecified: boolean;
  canAdd: boolean;
  canAddSpecified: boolean;
  refundable: boolean;
  refundableSpecified: boolean;
  providerDefinedModificationType: string;
}
export enum ModificationType {
  AddSegment,
  RemoveSegment,
  ReplaceSegment,
  AddPassenger,
  RemovePassenger,
  OptionsOnly,
  Other,
}
export enum FormattedTextTextTypeTextFormat {
  PlainText,
  HTML,
}
export class ServiceSubGroup {
  code: string;
}

export class typePassengerType {
  name: Name;
  loyaltyCard: LoyaltyCard[];
  discountCard: DiscountCard[];
  personalGeography: PersonalGeography;
  code: string;
  age: string;
  dOB: string;
  dOBSpecified: boolean;
  gender: string;
  pricePTCOnly: boolean;
  pricePTCOnlySpecified: boolean;
  bookingTravelerRef: string;
  accompaniedPassenger: boolean;
  residencyType: typeResidency;
  residencyTypeSpecified: boolean;
}
export class PassengerType extends typePassengerType {
  fareGuaranteeInfo: FareGuaranteeInfo;
}
export class Name {
  prefix: string;
  first: string;
  middle: string;
  last: string;
  suffix: string;
  travelerProfileId: string;
}

export class LoyaltyCard {
  providerReservationSpecificInfo: typeProviderReservationSpecificInfo[];
  key: string;
  supplierCode: string;
  allianceLevel: string;
  membershipProgram: string;
  cardNumber: string;
  status: string;
  membershipStatus: string;
  freeText: string;
  supplierType: typeProduct;
  supplierTypeSpecified: boolean;
  level: string;
  priorityCode: string;
  vendorLocationRef: string;
}

export class PersonalGeography {
  item: string;
  itemElementName: ItemChoiceType;
}
export enum ItemChoiceType {
  CityCode,
  CountryCode,
  StateProvinceCode
}
export enum typeResidency {
  Employee,
  National,
  Resident
}

export interface typeProviderReservationSpecificInfo {
  operatedBy: OperatedBy[];
  providerReservationInfoRef: ProviderReservationInfoRef;
  providerReservationLevel: boolean;
  providerReservationLevelSpecified: boolean;
  reservationLevel: boolean;
  reservationLevelSpecified: boolean;
}
export enum typeProduct {
  Air,
  Vehicle,
  Hotel,
  Rail,
  Cruise,
  Other
}
export class OperatedBy {
  private value: string;
}
export class ProviderReservationInfoRef {
  private key: string;
}
